const isValidMime = (mimeMask, actualMime, actualName) => {
  if (/\..+$/.test(mimeMask)) {
    return actualName.endsWith(mimeMask);
  }

  if (!mimeMask || actualMime === mimeMask) return true;
  if (!actualMime) return false;

  const mimeMaskSplit = mimeMask.split('/');
  const actualMimeSplit = actualMime.split('/');

  if (mimeMaskSplit[0] !== actualMimeSplit[0]) return false;
  return !(mimeMaskSplit[1] !== '*' && mimeMaskSplit[1] !== actualMimeSplit[1]);
};

const checkAcceptWithMime = (accept, mime, name) => {
  if (!accept) return true;

  const acceptSplit = accept
    .split(',')
    .map((i) => i.trim())
    .filter(Boolean);

  return acceptSplit.find((m) => isValidMime(m, mime, name));
};

export { checkAcceptWithMime, isValidMime };
